"use client";
import { Toast } from "@base-ui/react/toast";
const toastManager = Toast.createToastManager();
function normalizeV2Options(options) {
    const normalized = {
        ...options
    };
    if (normalized.textLink && !normalized.action) normalized.action = {
        label: normalized.textLink.text,
        href: normalized.textLink.url
    };
    if (void 0 !== normalized.hideCloseButton && void 0 === normalized.closeButton) normalized.closeButton = !normalized.hideCloseButton;
    if (normalized.titleClassName && !normalized.className) normalized.className = normalized.titleClassName;
    return normalized;
}
function createToast(variant, title, options) {
    const { description, action, closeButton = true, duration, className } = options ? normalizeV2Options(options) : {};
    return toastManager.add({
        title,
        description,
        type: variant,
        timeout: duration,
        data: {
            action,
            closeButton,
            className
        }
    });
}
const toast = {
    info: (title, options)=>createToast('info', title, options),
    success: (title, options)=>createToast('success', title, options),
    warning: (title, options)=>createToast('warning', title, options),
    error: (title, options)=>createToast('error', title, options),
    dismiss: (id)=>toastManager.close(id)
};
export { toast, toastManager };
